import React from 'react';
import Icon from '../../../components/AppIcon';

const CompanyBranding = () => {
  return (
    <div className="text-center mb-8">
      {/* Company Logo */}
      <div className="flex justify-center mb-6">
        <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center shadow-card">
          <Icon name="Calendar" size={32} color="white" />
        </div>
      </div>

      {/* Company Name and Tagline */}
      <div className="space-y-2">
        <h1 className="text-2xl font-bold text-foreground">
          Mitarbeiter Portal
        </h1>
        <p className="text-muted-foreground text-sm">
          Sichere Schichtplanung für Ihr Unternehmen
        </p>
      </div>

      {/* Company Info */}
      <div className="mt-6 p-4 bg-muted/30 rounded-lg">
        <div className="flex items-center justify-center space-x-2 text-xs text-muted-foreground">
          <Icon name="Building" size={14} />
          <span>Enterprise Solutions GmbH</span>
        </div>
        <div className="flex items-center justify-center space-x-2 text-xs text-muted-foreground mt-1">
          <Icon name="MapPin" size={14} />
          <span>Berlin, Deutschland</span>
        </div>
      </div>

      {/* Trust Indicators */}
      <div className="mt-4 flex justify-center space-x-4">
        <div className="flex items-center space-x-1">
          <Icon name="Shield" size={12} className="text-success" />
          <span className="text-xs text-muted-foreground">SSL gesichert</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="Lock" size={12} className="text-success" />
          <span className="text-xs text-muted-foreground">DSGVO konform</span>
        </div>
      </div>
    </div>
  );
};

export default CompanyBranding;